import { ContentCopy } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaConfirmActionDialog from "~/modules/app/components/GaiaConfirmActionDialog";
import useDestructiveActionBlocker from "~/modules/app/hooks/useDestructiveActionBlocker";

import { MapEditorObservationPanelObservationFragment } from "../../fragments.generated";
import { useCloneObservationMutation } from "../../useCloneObservationMutation";

export interface ObservationCloneButtonProps {
    observationId: string;
    onCloned?: (clonedObservation: MapEditorObservationPanelObservationFragment) => void;
    disabled?: boolean;
}

export function ObservationCloneButton({ observationId, onCloned, disabled }: ObservationCloneButtonProps) {
    const { t } = useTranslation("mapEditor");
    const [cloneObservationAction, { loading: isCloning }] = useCloneObservationMutation();

    const handleClone = async () => {
        const result = await cloneObservationAction(observationId);
        const clonedObservation = result.data?.observationClone;
        if (clonedObservation) onCloned?.(clonedObservation);
    };

    const cloneBlocker = useDestructiveActionBlocker(handleClone, onCloned !== undefined);

    if (onCloned === undefined) return null;

    return (
        <>
            <GaiaConfirmActionDialog
                title={t("featureDetailObservation.cloneDialogTitle")}
                description={t("featureDetailObservation.cloneDialogDescription")}
                blocker={cloneBlocker}
            />
            <Tooltip title={t("featureDetailObservation.cloneDialogTitle")} placement="left">
                <IconButton loading={isCloning} disabled={disabled} onClick={cloneBlocker.onAction}>
                    <ContentCopy fontSize="small" />
                </IconButton>
            </Tooltip>
        </>
    );
}
